var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_cof.js
// module id = 233
// module chunks = 168707334958949